import { render, staticRenderFns } from "./client-roster.vue?vue&type=template&id=f3e7fa34&scoped=true"
import script from "./client-roster.vue?vue&type=script&lang=js"
export * from "./client-roster.vue?vue&type=script&lang=js"
import style0 from "./client-roster.vue?vue&type=style&index=0&id=f3e7fa34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e7fa34",
  null
  
)

export default component.exports